import { useContext, useCallback } from 'react';
import * as lodash from 'lodash';
import { AjaxContext, AppContext, EMPTY_ARRAY, UserContext, ERROR_SEVERITY, EApiResponseCode } from 'commons-ui';
import { EOutboundURL } from './helper';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const { user } = useContext(UserContext);

	const addCampaignData = useCallback(async (athenaQueryText: string, campaignName: string, showAlert: any): Promise<boolean> => {
		try {
			const response = await postData({
				endpoint: EOutboundURL.ADD_CAMPAIGN_DATA,
				queryParams: {
					appName
				},
				body: {
					athenaQueryText: athenaQueryText.trim(),
					campaignName: campaignName.trim(),
					emailId: user?.email
				}
			});
			if (response?.status !== EApiResponseCode.SUCCESS) {
				showAlert('Internal server error', { type: ERROR_SEVERITY.ERROR });
				return false;
			}
			if (response?.data?.success === false) {
				showAlert(`${lodash.get(response, ['data', 'externalMessage'], 'Error in api')}`, { type: ERROR_SEVERITY.ERROR });
				return false;
			}
		} catch (error: any) {
			showAlert('Some error occured', { type: ERROR_SEVERITY.ERROR });
			return false;
		}
		return true;
	}, EMPTY_ARRAY);

	const uploadCampaignDataCsv = async (csvFile: File, campaignName: string, showAlert: Function): Promise<boolean> => {
		try {
			const formData = new FormData();
			formData.append('csv', csvFile);
			formData.append('appName', appName);
			formData.append('campaignName', campaignName.trim());
			formData.append('emailId', user?.email || '');

			const response = await postData({
				endpoint: EOutboundURL.UPLOAD_CAMPAIGN_DATA_CSV,
				body: formData,
				queryParams: {
					appName
				}
			});

			if (response?.status !== EApiResponseCode.SUCCESS) {
				showAlert('Internal server error', { type: ERROR_SEVERITY.ERROR });
				return false;
			}

			if (response?.data?.success === true) {
				showAlert('CSV upload request submitted successfully!!', { type: 'success' });
				return true;
			}
			if (response?.data?.success === false) {
				showAlert(`${lodash.get(response, ['data', 'externalMessage'], 'Error in api')}`, { type: ERROR_SEVERITY.ERROR });
				return false;
			}
			return false;
		} catch (error: any) {
			showAlert(`Error uploading CSV: ${error.message}`, { type: 'error' });
			return false;
		}
	};

	return {
		addCampaignData,
		uploadCampaignDataCsv
	};
};

export default useService;
